import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import SearchFilter from '../Reusable/SearchFilter';
import withTranslations from '../../utils/HighOrderComponent';
import MunicipalityRow from './MunicipalityRow';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import ModalForUpdateMunicipalityName from './ModalForUpdateMunicipalityName';

class MunicipalityTable extends Component {
  constructor() {
    super();
    this.state = {
      showModalForAddMunicipality: false,
    };
  }

  showModal = (e) => {
    this.setState({
      showModalForAddMunicipality: true,
    });
  };

  handlePreviewClose = () => {
    this.setState({
      showModalForAddMunicipality: false,
    });
  };

  handleAddMunicipality = (place) => {
    const { NotificationMessages } = this.props.t;
    this.props.createMunicipality(
      place,
      this.handlePreviewClose,
      NotificationMessages
    );
  };

  render() {
    const { t, updateMunicipality, placeList } = this.props || {},
      { HeaderColumns, titleTable, Tooltips, NotificationMessages } = t || {};

    const municpalityList = this.props.municipalityList?.map(
      (municipality, index) => (
        <MunicipalityRow
          index={index + 1}
          key={municipality.id}
          municipality={municipality}
          updateMunicipality={updateMunicipality}
          placeList={placeList}
          NotificationMessages={NotificationMessages}
        />
      )
    );

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className="col-md-3">
                  <SearchFilter noSearchColums={0} />
                </Col>
                <Col className="col-md-1 text-right">
                  <Link id="addMunicipality" onClick={this.showModal} to="#">
                    <Tooltip
                      title={Tooltips.addMunicipality}
                      placement="top"
                      arrow={true}
                    >
                      <i className="fas fa-plus fa-2x" />
                    </Tooltip>
                  </Link>
                </Col>
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr className=" text-center">
                  <th className="align-top" width="4%">
                    #
                  </th>
                  <th className="align-top">{HeaderColumns.name}</th>
                  <th className="align-top">{HeaderColumns.place}</th>
                  <th className="align-top">{HeaderColumns.addPlace}</th>
                  <th className="align-top">
                    {HeaderColumns.updateMunicipality}
                  </th>
                </tr>
              </thead>
              <tbody>{municpalityList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.state.showModalForAddMunicipality && (
          <ModalForUpdateMunicipalityName
            show={this.state.showModalForAddMunicipality}
            handleClose={this.handlePreviewClose}
            createMunicipality={this.handleAddMunicipality}
            signalOfUpdate={false}
            placeList={placeList}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(MunicipalityTable, 'MunicipalityTable');
